import React from 'react';
import { connect } from 'react-redux';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _debounce from 'lodash/debounce';
import PropTypes from 'prop-types';
// Custom
import { getInstallationDoors, getInstallationSources, getInstallationDevices } from 'actions';
import SubViewTemplate from 'components/templates/SubViewTemplate';
import InstallationConfigurationDoors from './InstallationConfigurationDoors';
import InstallationConfigurationSources from './InstallationConfigurationSources';
import InstallationConfigurationDevices from './InstallationConfigurationDevices';

class InstallationConfiguration extends React.Component {
  constructor(props) {
    super(props);

    this.handleRefresh = this.handleRefresh.bind(this);
    this.handleReloadConfiguration = this.handleReloadConfiguration.bind(this);

    // Desynchro reload management
    this.performRefreshAfterDesynchro = _debounce(this.doLoadConfiguration, 2000);
  }

  componentDidMount() {
    this.doLoadConfiguration();
  }

  componentDidUpdate() {
    const { devicesDesynchronized } = this.props;

    // Desynchro catching
    if (devicesDesynchronized) {
      // Debounce a refresh
      this.performRefreshAfterDesynchro();
    } else {
      // Cancel current debounce, if any
      this.performRefreshAfterDesynchro.cancel();
    }
  }

  componentWillUnmount() {
    // Cancel current debounce, if any
    this.performRefreshAfterDesynchro.cancel();
  }

  // Handlers
  handleRefresh(e) {
    e.preventDefault();
    this.doLoadConfiguration();
  }

  handleReloadConfiguration() {
    this.doLoadConfiguration();
  }

  // Private
  doLoadConfiguration() {
    const {
      params, handleGetDoors, handleGetSources, handleGetDevices,
    } = this.props;
    handleGetDoors(params.id);
    handleGetSources(params.id);
    handleGetDevices(params.id);
  }

  render() {
    const { params } = this.props;

    return (
      <SubViewTemplate
        title={
          <LocalizedMessage id="title.installationConfiguration" />
        }
        onRefresh={this.handleRefresh}
      >
        <div className="row">
          {/*
            <div className="col-12">
              <CollapseBoxTemplate
                title={<LocalizedMessage id="title.configuration" />}
              >
                <div className="p-4">
                  <span>General configuration information here (shema representing the whole configuration)</span>
                </div>
              </CollapseBoxTemplate>
            </div>
          */}
          <div className="col-md-6 col-sm-12 mt-4">
            <InstallationConfigurationDoors
              {...params}
              onUpdate={this.handleReloadConfiguration}
            />
          </div>
          <div className="col-md-6 col-sm-12 mt-4">
            <InstallationConfigurationSources
              {...params}
              onUpdate={this.handleReloadConfiguration}
            />
          </div>
          <div className="col-12 mt-4">
            <InstallationConfigurationDevices
              {...params}
              onUpdate={this.handleReloadConfiguration}
            />
          </div>
        </div>
      </SubViewTemplate>
    );
  }
}

InstallationConfiguration.propTypes = {
  params: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  }).isRequired,
  devicesDesynchronized: PropTypes.bool.isRequired,
  handleGetDoors: PropTypes.func.isRequired,
  handleGetSources: PropTypes.func.isRequired,
  handleGetDevices: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  devicesDesynchronized: state.deviceData.desynchronized,
});

const mapDispatchToProps = (dispatch) => ({
  handleGetDoors: (id) => {
    dispatch(getInstallationDoors(id));
  },
  handleGetSources: (id) => {
    dispatch(getInstallationSources(id));
  },
  handleGetDevices: (id) => {
    dispatch(getInstallationDevices(id));
  },
});

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps,
)(InstallationConfiguration);



// WEBPACK FOOTER //
// ./routes/app/routes/installations/routes/show/routes/configuration/routes/index/components/InstallationConfiguration.js